<template>
  <div class="tree-collapse-item" :class="{ ml: level > 1 }">
    <div class="self">
      <div
        class="icon-wrap"
        :class="{ pointer: value[childProp] && value[childProp].length }"
        @click="onExpand"
      >
        <i class="line" v-if="showLine"></i>
        <img class="icon-status" :src="iconStatus" />
      </div>
      <div class="content-wrap">
        <div class="name-wrap">
          <span class="name">{{ value.name }}</span>
        </div>
        <div class="num-wrap">
          <slot name="num" :data="value"></slot>
        </div>
        <div class="btn-wrap">
          <slot name="btn" :data="value"></slot>
        </div>
      </div>
    </div>
    <div
      class="children"
      ref="children"
      v-if="level < maxLevel && value[childProp] && value[childProp].length"
    >
      <TreeCollapseItem
        v-for="(item, index) in value[childProp]"
        :key="index"
        :value="item"
        :next-value="value[childProp][index + 1]"
        :level="level + 1"
        :child-prop="childProp"
        :max-level="maxLevel"
      >
        <template slot="num" slot-scope="{ data }">
          <slot name="num" :data="data"></slot>
        </template>
        <template slot="btn" slot-scope="{ data }">
          <slot name="btn" :data="data"></slot>
        </template>
      </TreeCollapseItem>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeCollapseItem',
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    nextValue: {
      default: undefined,
    },
    childProp: {
      type: String,
      default: 'children',
    },
    level: {
      type: Number,
      default: 1,
    },
    maxLevel: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      icon: {
        close: require('@/assets/images/exam/icon-tree-close.png'),
        open: require('@/assets/images/exam/icon-tree-open.png'),
        end: require('@/assets/images/exam/icon-tree-end.png'),
        none: require('@/assets/images/exam/icon-tree-none.png'),
      },
    };
  },
  computed: {
    iconStatus() {
      if (this.value[this.childProp] && this.value[this.childProp].length) {
        return this.value.expandStatus ? this.icon.open : this.icon.close;
      } else if (this.level == this.maxLevel) {
        return this.icon.end;
      }
      return this.icon.none;
    },
    showLine() {
      if (this.level == 1) return false;
      // 有后续节点，并且自己没有展开，则展示线条
      return this.nextValue && !this.value.expandStatus;
    },
  },
  methods: {
    // on event
    onExpand() {
      if (!this.$refs.children) return;
      let ele = window.$(this.$refs.children);
      this.$set(this.value, 'expandStatus', this.value.expandStatus ? 0 : 1);
      this.value.expandStatus ? ele.slideDown(200) : ele.slideUp(200);
      this.$emit('on-expand', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-collapse-item {
  color: #333;
  .self {
    display: flex;
    .icon-wrap {
      padding: 20px 0;
      position: relative;
      width: 35px;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      &.pointer {
        cursor: pointer;
      }
      .line {
        display: inline-block;
        width: 3px;
        height: 100%;
        background-color: #feded4;
        position: absolute;
        left: 14px;
        top: 38px;
      }
      .icon-status {
        width: 26px;
        height: 26px;
        position: absolute;
        flex: none;
      }
    }
    .content-wrap {
      display: flex;
      flex-grow: 1;
      padding: 20px 0;
      border-bottom: 1px solid #eee;
    }
    .name-wrap {
      flex-grow: 1;
      font-size: 14px;
      line-height: 1;
      margin-top: 11px;
      padding-right: 10px;
    }
    .num-wrap {
      width: 370px;
      flex-shrink: 0;
      white-space: nowrap;
      color: #343434;
      font-size: 15px;
      line-height: 1;
      margin-top: 11px;
    }
    .btn-wrap {
      width: 100px;
      flex-shrink: 0;
      text-align: center;
    }
  }
  .ml {
    margin-left: 35px;
  }
  .children {
    overflow: hidden;
    display: none;
  }
}
</style>
